<div class="tw-flex tw-flex-wrap tw-text-left tw-py-1 tw-gap-2 tw-items-center">
  <div class="tw-inline-block">
    <span class="tw-text-lg tw-font-bold tw-text-black tw-mb-0">&nbsp;{{discountedPrice | prettyPrice}}</span>
    <span class="tw-mb-0 tw-text-xs tw-text-grayMid">&nbsp; /{{duration}}</span>
  </div>
  <div *ngIf="discountedPrice<originalPrice" class="tw-inline-block tw-line-through tw-decoration-grayMid">
    <span class="tw-text-xs tw-font-bold tw-text-grayMid tw-mb-0">&nbsp;{{originalPrice | prettyPrice}}</span>
    <span class="tw-mb-0 tw-text-xs tw-text-grayMid">&nbsp; /{{duration}}</span> 
  </div>
  <div class="tw-text-xs tw-text-grayMid">(Inclusive of GST)</div>
</div>